module.exports = __webpack_public_path__ + "img/positive.b3c97583.png";